import { theme } from "./theme";
import type { AnimationStep } from "./store";

/** Cubic ease-in-out. */
export function easeInOut(t: number): number {
  return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
}

export function easeOut(t: number): number {
  return 1 - Math.pow(1 - t, 3);
}

/** Returns animation progress in [0..1] given current time. */
export function progress(anim: AnimationStep, now: number): number {
  const dur =
    anim.kind === "slide"
      ? theme.slideMs
      : anim.kind === "captureLabel"
        ? theme.captureLabelMs
        : theme.captureFlashMs;
  return Math.min(1, Math.max(0, (now - anim.startedAt) / dur));
}

/** Clamps and returns the easing curve for the animation. */
export function eased(anim: AnimationStep, now: number): number {
  const t = progress(anim, now);
  return anim.kind === "slide" ? easeInOut(t) : easeOut(t);
}
